import { GrpStandardScreen } from "../../../layout/grp-standard-screen";
import { GrpSubMenusPathEnum } from "../../../shared/enums/grp-menus.enum";
import useStandardGrpFetch from "../../../shared/hooks/useStandardGrpFetch";

import { Config } from "./config";
import tableColumns from "./components/table-columns";
import zonesUseOccupationParser from "./parsers/zones-use-occupation.parser";

import { CreateInputs, FilterInputs, UpdateInputs } from "./components/inputs";
import { zonesUseOccupationValidator } from "./validators/zones-use-occupation.validator";

export default () => {
    const { content, fetch, loading } = useStandardGrpFetch({
        subMenuPath: GrpSubMenusPathEnum.ZONING_USE_OCCUPATION,
        relations: ["zoning"],
        config: Config,
    });

    return (
        <GrpStandardScreen
            title="PARÂMETROS DE OCUPAÇÃO DO SOLO "
            url={Config.api.path}
            columns={tableColumns}
            dataSource={content?.data}
            filters={{ fields: FilterInputs.map((input) => input()) }}
            register={{
                fields: CreateInputs.map((input) => input()),
                validator: zonesUseOccupationValidator,
                parser: zonesUseOccupationParser,
            }}
            update={{
                fields: UpdateInputs.map((input) => input()),
                validator: zonesUseOccupationValidator,
                parser: zonesUseOccupationParser,
            }}
            pagination={content?.paginate}
            loading={loading}
            reFetch={fetch}
        />
    );
};
